import React, { useState } from 'react';
import { Form, Input, Button, Alert, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LmHeader from '../components/LmHeader.jsx';
import LmFooter from '../components/LmFooter.jsx';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Определяем тип пользователя из URL параметра
  const userType = searchParams.get('type') || 'client';
  const isClient = userType === 'client';

  const backTo = isClient ? '/enter' : '/login';

  const onFinish = async (values) => {
    setError('');
    setLoading(true);

    try {
      const endpoint = isClient
        ? 'https://limitverify.ru:5000/api/clients/forgot-password'
        : 'https://limitverify.ru:5000/api/auth/forgot-password';

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: values.email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        message.success('Ссылка для восстановления пароля отправлена на ваш email');
      } else {
        setError(data.error || 'Произошла ошибка');
      }
    } catch (err) {
      setError('Произошла ошибка при отправке запроса');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lm-page">
      <LmHeader actions={[{ label: 'Вход', onClick: () => navigate(backTo) }]} />

      <main className="lm-content lm-content--center">
        <div className="lm-auth">
          {success ? (
            <>
              <div className="lm-auth__head">
                <h1 className="lm-auth__title">Проверьте почту</h1>
                <span className="lm-auth__sub">
                  Если аккаунт с указанным email существует, мы отправили ссылку для восстановления пароля.
                </span>
              </div>
              <button
                type="button"
                className="lm-btn lm-btn--block"
                onClick={() => navigate(backTo)}
              >
                Вернуться к входу
              </button>
            </>
          ) : (
            <>
              <div className="lm-auth__head">
                <h1 className="lm-auth__title">Восстановление пароля</h1>
                <span className="lm-auth__sub">
                  {isClient
                    ? 'Введите ваш email для восстановления пароля от личного кабинета'
                    : 'Введите ваш email для восстановления пароля от системы'}
                </span>
              </div>

              {error && (
                <Alert message={error} type="error" closable onClose={() => setError('')} />
              )}

              <Form name="forgot-password" onFinish={onFinish} layout="vertical" requiredMark={false} className="lm-auth__form">
                <Form.Item
                  name="email"
                  label="Введите email"
                  style={{ marginBottom: 0 }}
                  rules={[
                    { required: true, message: 'Введите email' },
                    { type: 'email', message: 'Введите корректный email' }
                  ]}
                >
                  <Input placeholder="email@example.com" />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button htmlType="submit" loading={loading} block style={{ textTransform: 'uppercase' }}>
                    Отправить ссылку восстановления
                  </Button>
                </Form.Item>

                <button type="button" className="lm-link" onClick={() => navigate(backTo)}>
                  Вернуться к входу
                </button>
              </Form>
            </>
          )}
        </div>
      </main>

      <LmFooter />
    </div>
  );
};

export default ForgotPassword;
